import React, { useState, useEffect } from 'react';

const EligibleSupportersList = ({ sponsorshipId, onInvite }) => {
  const [eligibleSupporters, setEligibleSupporters] = useState([]);
  const [selectedSupporters, setSelectedSupporters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inviting, setInviting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    fetchEligibleSupporters();
  }, [sponsorshipId]);

  const fetchEligibleSupporters = async () => {
    try {
      const response = await fetch(`/api/v1/sponsorships/${sponsorshipId}/eligible_supporters`, {
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      });

      const data = await response.json();

      if (response.ok) {
        setEligibleSupporters(data.data.eligible_supporters || []);
      } else {
        setError(data.message || 'Erreur lors du chargement des membres éligibles');
      }
    } catch (err) {
      setError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const toggleSupporter = (supporterId) => {
    setSelectedSupporters(prev => {
      if (prev.includes(supporterId)) {
        return prev.filter(id => id !== supporterId);
      } else {
        return [...prev, supporterId];
      }
    });
  };

  const handleInvite = async () => {
    if (selectedSupporters.length === 0) {
      return;
    }

    setInviting(true);
    setError(null);

    try {
      const response = await fetch(`/api/v1/sponsorships/${sponsorshipId}/invite_supporters`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({
          user_ids: selectedSupporters
        })
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setSelectedSupporters([]);
        if (onInvite) {
          onInvite(data.data.invited_users);
        }
      } else {
        setError(data.message || 'Erreur lors de l\'envoi des invitations');
      }
    } catch (err) {
      setError('Erreur de connexion. Veuillez réessayer.');
    } finally {
      setInviting(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: '#fff', borderRadius: 24, border: '1px solid rgba(124,40,55,0.12)', boxShadow: '0 18px 44px rgba(124,40,55,0.08)', padding: '24px 26px' }}>
        <h4 className="card-title" style={{ color: '#2c0e16', fontWeight: 800 }}>
          Inviter des Parrains de Soutien
        </h4>

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success" role="alert">
            ✓ Invitations envoyées avec succès !
          </div>
        )}

        {eligibleSupporters.length === 0 ? (
          <p className="text-muted">Aucun membre éligible disponible pour ce niveau.</p>
        ) : (
          <>
            {/* Liste scrollable */}
            <div 
              className="list-group mb-3" 
              style={{ maxHeight: '300px', overflowY: 'auto', borderRadius: 16, overflow: 'hidden' }}
            >
              {eligibleSupporters.map(supporter => (
                <label 
                  key={supporter.id}
                  className={`list-group-item list-group-item-action ${
                    selectedSupporters.includes(supporter.id) ? 'active' : ''
                  }`}
                  style={{ cursor: 'pointer', borderColor: 'rgba(124,40,55,0.08)' }}
                >
                  <div className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={selectedSupporters.includes(supporter.id)}
                      onChange={() => toggleSupporter(supporter.id)}
                    />
                    <div>
                      <strong>{supporter.name}</strong>
                      <br />
                      <small className="text-muted">
                        {supporter.email} - {supporter.level}
                      </small>
                    </div>
                  </div>
                </label>
              ))}
            </div>

            {/* Footer avec compteur et bouton */}
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted">
                {selectedSupporters.length} parrain(s) sélectionné(s)
              </span>
              <button
                type="button"
                className="btn"
                style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', color: '#fff', border: 'none', borderRadius: 14, fontWeight: 700, padding: '12px 18px' }}
                disabled={selectedSupporters.length === 0 || inviting}
                onClick={handleInvite}
              >
                {inviting ? 'Envoi en cours...' : 'Envoyer les Invitations'}
              </button>
            </div>
          </>
        )}
    </div>
  );
};

export default EligibleSupportersList;